// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M-KK","type":"styles_type__BkmUA","choices":"styles_choices__3JToK"};